import { Link } from 'react-router-dom';
import styles from './WhyChooseUs.module.css';
import whyChooseUs1 from '../../assets/images/whychooseus-1.png';
import whyChooseUs2 from '../../assets/images/whychooseus-2.png';
import whyChooseUs3 from '../../assets/images/whychooseus-3.png';

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      title: '24/7 Nursing Staff',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Resident Care',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Quality Support',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 4,
      title: 'Caring Staff',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" fill="currentColor"/>
        </svg>
      )
    }
  ];

  return (
    <section className={styles.whyChooseSection}>
      <div className={styles.container}>
        <div className={styles.imagesColumn}>
          <div className={styles.imageGrid}>
            <div className={styles.imageWrapper + ' ' + styles.image1}>
              <img src={whyChooseUs1} alt="Elderly couple" />
            </div>
            <div className={styles.imageWrapper + ' ' + styles.image2}>
              <img src={whyChooseUs3} alt="Happy senior" />
            </div>
            <div className={styles.imageWrapper + ' ' + styles.image3}>
              <img src={whyChooseUs2} alt="Senior with flowers" />
            </div>
          </div>
        </div>

        <div className={styles.contentColumn}>
          <div className={styles.content}>
            <p className={styles.tag}>WHY CHOOSE US</p>
            <h2 className={styles.heading}>The right care for your loved ones</h2>
            <p className={styles.description}>
              At All For You Home Health Care, we provide compassionate, professional care
              tailored to your family's needs. Our experienced team is available around the
              clock to ensure your loved ones receive the highest quality support in the
              comfort of their own home.
            </p>

            <div className={styles.featuresGrid}>
              {features.map((feature) => (
                <div key={feature.id} className={styles.feature}>
                  <div className={styles.featureIcon}>{feature.icon}</div>
                  <span className={styles.featureTitle}>{feature.title}</span>
                </div>
              ))}
            </div>

            <div className={styles.buttonGroup}>
              <Link to="/about" className={styles.primaryButton}>
                More about us
              </Link>
              <Link to="/services" className={styles.secondaryButton}>
                Browse services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
